<script>
    export default {
        name: "lang",

        data() {
            return {
                locale: window.locale,
                languages: window.languages,
                display : {
                    dev : 'dev',
                    en : 'English',
                    'zh-HK' : '中文',
                }
            }
        },
        methods: {
            setLocale(key) {
                let self = this;
                axios.get('/user-preference/locale/' + key)
                    .then((response) => {
                        location.reload();
                    })
                    .catch((error) => {
                        self.$store.commit('setError',  error.response.data)
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Lang/Lang.vue